import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import {
    MotifTable,  MotifPagination,
    MotifCheckbox,
    MotifSearch,
} from "@ey-xd/motif-react";

import { TableHeader } from "../partnerFileUpload/TableHeader";
import { useNavigate } from "react-router-dom";
import "./adminLandingPage.scss"; 
import { MotifProgressLoader, MotifButton, MotifIcon, MotifToast } from "@ey-xd/motif-react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getAccount, getAccountByEmail, searchGraphUsers } from "../../common/services/commonService";
import { downloadIcon } from '../../common/MotifIcons';
import useGetApplicationData from "../../common/redux/common/getApplicationData/useGetApplicationData";
import { useDispatch } from "react-redux";
import { getApplicationData } from "../../common/redux/common/getApplicationData/getApplicationDataSlice";
import { getFilesEngagementData, getUtilityData, getAdminEngagementData, getAdminFilesData, adminDownloadFileRequest, adminDownloadFileSuccess, adminDownloadFileFailure, adminOriginalFileNamesRequest, adminOriginalFileNamesSuccess, adminOriginalFileNamesFailure, adminStartAnonymizationRequest, adminUploadFileRequest, adminBookmarkFileRequest, adminExportExcelRequest } from "../partnerFileUpload/redux/partnerFileUploadSlice";
import { ApiStatus } from "../../common/services/api-status.enum";
import usePartnerFileUpload from "../partnerFileUpload/hooks/usePartnerFileUpload";
import AsyncAvatar from "../../common/async-avatar/async-avatar/AsyncAvatar";
import "../partnerFileUpload/partnerFileUpload.scss"; 
import data from "../partnerFileUpload/staticJson";
import AdminExportExcelPanel from "./AdminExportExcelPanel";

import { useSelector} from 'react-redux';
import { adminGoldCountsRequest } from "../partnerFileUpload/redux/partnerFileUploadSlice";
import { filter } from "jszip";
import logger from "../../common/utils/logger";

export const AdminLandingPage = () => {
    // Calculate total width to match MotifTable width
    // MotifTable columns: 120+170+170+170+180+180+160+150+130+130+130+210 = 1900px
    const PARENT_TABLE_WIDTH = 1900; // Match MotifTable width
    
    const [searchValue, setSearchValue] = useState("");
    const [columnFilters, setColumnFilters] = useState({
        engagementId: "",
        goldBadge: "",
        clientName: "",
        engagementName: "",
        area: "",
        country: "",
        transactionType: "",
        function: "",
        sortCodes: "",
        sector: "",
        subSector: "",
        subSubSector: "",
        revenueRange: "",
        partnerName: ""
    });
    const [searchUser, setSearchUser] = useState("");
    const [isLoading, setIsLoading] = React.useState(false);
    const [fileData, setFileData] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [engagementData, setEngagementData] = useState([]);
    const [engagementIdList, setEngagementIdList] = useState([]);
    const navigation = useNavigate();
    const [userData, setUserData] = useState([]);
    const [engagementId, setEngagementId] = useState(0);
    const [baseURL, setBaseURL] = useState("");
   const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 8; // Show 15 records per page
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const [buttonClicked, setButtonClicked] = React.useState("");
    const [checkedEngIds, setCheckedEngIds] = useState([]);
    const userProfileDetails = JSON.parse(sessionStorage.getItem("profileDetails"));
    const dispatch = useDispatch();
    const { getApplicationDetail, error } = useGetApplicationData();
    const { utilityData, filesEngagementData, adminEngagementData, adminFilesData, adminDownloadFileData, adminOriginalFileNamesData, adminStartAnonymizationData, adminManualUploadData, adminBookmarkFileData, adminExportExcelData } = usePartnerFileUpload();
    const [copied, setCopied] = React.useState(false);
    const [copiedValue, setCopiedValue] = React.useState('');
    const [expandedRows, setExpandedRows] = useState(new Set());
    const [filesDataCache, setFilesDataCache] = useState({});
    const [showManualUploadDialog, setShowManualUploadDialog] = useState(false);
    const [manualUploadFiles, setManualUploadFiles] = useState([]);
    const [manualUploadError, setManualUploadError] = useState(null);
    const [manualUploadRequestId, setManualUploadRequestId] = useState(null);
    const [manualUploadArea, setManualUploadArea] = useState(null);
    // Toast state for admin actions (download/upload)
    const [adminToastVisible, setAdminToastVisible] = useState(false);
    const [adminToastVariant, setAdminToastVariant] = useState('success');
    const [adminToastTitle, setAdminToastTitle] = useState('');
    const [adminToastSubtitle, setAdminToastSubtitle] = useState('');
    const [isExportExcelPanelOpen, setIsExportExcelPanelOpen] = useState(false);
    const [isAccordionPageLoading, setIsAccordionPageLoading] = useState(false);
    const [activeAccordionGuid, setActiveAccordionGuid] = useState(null);
    const lastDownloadRef = useRef(0);
    const lastUploadRef = useRef(0);
    // Track per-upload request status to gate toasts only on fresh LOADING -> SUCCESS/ERROR transitions
    const uploadStatusHistoryRef = useRef({}); // { requestId: { lastStatus } }
    // Gold layer counts from Redux (using partner slice namespace)
    const adminGoldCountsData = useSelector(state => state?.partnerFileData?.adminGoldCounts?.adminGoldCountsData);

    // Define getData before any effects that reference it to avoid TDZ errors
    const getData = useCallback((showLoader = false) => {
       
        const userAccount = getAccount();
        const username = userAccount?.username;

       
        if (!username) {
            logger.info("No username found, not calling API");
            return;
        }

        /* istanbul ignore next */
        if (showLoader) {
            setIsLoading(true);
        }

        const payload = {
            "emailAddress": username
        };

        dispatch(getAdminEngagementData(payload)); // Use new admin engagement API

    }, [dispatch]);
    // Remove extra render-key logic; we'll control fetch order instead
    useEffect(() => {
        // Step 1: fetch gold counts first
        dispatch(adminGoldCountsRequest());
    }, [dispatch]);

    useEffect(() => {
        // Step 2: once gold counts are loaded (or errored), fetch engagement data
        if (adminGoldCountsData?.status === ApiStatus.SUCCESS || adminGoldCountsData?.status === ApiStatus.ERROR) {
            // Original getData triggers admin engagement API
            getData();
        }
    }, [adminGoldCountsData?.status, getData]);

    // Auto-hide toast after 5 seconds whenever it becomes visible
    useEffect(() => {
        if (!adminToastVisible) return;
        const timer = setTimeout(() => {
            setAdminToastVisible(false);
        }, 5000); // 5 seconds
        return () => clearTimeout(timer);
    }, [adminToastVisible]);
    // Track selected control IDs per engagement GUID for enabling anonymization button
    const [selectedControlsByEngagement, setSelectedControlsByEngagement] = useState({});
    
    // File table pagination state
    const [fileCurrentPage, setFileCurrentPage] = useState(1);
    const fileRowsPerPage = 10;
    const fileStartIndex = (fileCurrentPage - 1) * fileRowsPerPage;
    const fileEndIndex = fileStartIndex + fileRowsPerPage;
   
    const toggleRowExpansion = (engagementId, engagementGuid, area) => {
        setExpandedRows(prev => {
            if (prev.has(engagementId)) {
                setIsAccordionPageLoading(false);
                setActiveAccordionGuid(null);
                const collapsed = new Set();
                return collapsed; // collapse all (only one allowed)
            }
             const next = new Set([engagementId]);
             setFileCurrentPage(1);
            const guidToUse = engagementGuid; // Fallback to engagementId if GUID not available
            setActiveAccordionGuid(guidToUse);
            setIsAccordionPageLoading(true);
            const payload = { engagementGUID: guidToUse };
            dispatch(getAdminFilesData(payload));
            dispatch(adminOriginalFileNamesRequest({ engagementGUID: guidToUse, area }));
            return next;
        });
    };

    useEffect(() => {
        if (!activeAccordionGuid || !isAccordionPageLoading) return;
        const filesState = adminFilesData?.data?.[activeAccordionGuid];
        const namesState = adminOriginalFileNamesData?.data?.[activeAccordionGuid];
        const hasRequestState = !!filesState || !!namesState;
        if (!hasRequestState) return;

        const filesLoading = filesState?.status === ApiStatus.LOADING;
        const namesLoading = namesState?.status === ApiStatus.LOADING;
        if (!filesLoading && !namesLoading) {
            setIsAccordionPageLoading(false);
        }
    }, [activeAccordionGuid, isAccordionPageLoading, adminFilesData, adminOriginalFileNamesData]);
    /* istanbul ignore next */
    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        setCheckedEngIds(prev =>
            checked ? [...prev, value] : prev.filter(id => id !== value)
        );
    };

    



    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    /* istanbul ignore next */
    const handleFilePageChange = (newPage) => {
        setFileCurrentPage(newPage);
    };

    /* istanbul ignore next */
    const setBaseURLByArea = (area) => {
        if ((area || "").toLowerCase() === "americas") {
            setBaseURL(process.env.REACT_APP_API_URL_US);
        } else if ((area || "").toLowerCase() === "emeia") {
            setBaseURL(process.env.REACT_APP_API_URL_EU);
        } else if ((area || "").toLowerCase() === "apac") {
            setBaseURL(process.env.REACT_APP_API_URL_AU);
        }
    };

       /* istanbul ignore next */
       useEffect(() => {
        if (utilityData?.status === ApiStatus.SUCCESS) {
            if (buttonClicked === "add") {
                const latestData = utilityData?.data;
                const matchedItem = latestData?.find(item => item.engagementId === engagementId);
                
                setButtonClicked("");
            }
        }
    }, [utilityData?.status]);

  
    useEffect(() => {
        const cachedData = sessionStorage.getItem("userDataCache"); // Check session storage for cached data
        if (cachedData) {
            // If data exists in session storage, use it
            if (cachedData) {
                setUserData(JSON.parse(cachedData)); // Assuming the data is stored as a JSON string
            }
        } else {
            if (
                !getApplicationDetail ||
                Object.keys(getApplicationDetail).length === 0
            ) {
                dispatch(getApplicationData());
            }
            if (
                getApplicationDetail &&
                Object.keys(getApplicationDetail).length > 0
            ) {
                setUserData(getApplicationDetail);

                sessionStorage.setItem(
                    "userDataCache", // Key for user data in session storage
                    JSON.stringify(getApplicationDetail)
                );
            } else if (error) {
                navigation("/"); // Redirect if unauthorized
            }
        }
    }, [dispatch, getApplicationDetail, error, navigation]);

    useEffect(() => {
        if (fileData.length === 0 && adminEngagementData?.status !== ApiStatus.LOADING) {
            getData();
        } 
    }, []); // Empty dependency array - only run once on mount

    /* istanbul ignore next */
    React.useEffect(() => {
        if ((rowData?.area || "").toLowerCase() === "americas") {
            setBaseURL(process.env.REACT_APP_API_URL_US)
        } else if ((rowData?.area || "").toLowerCase() === "emeia") {
            setBaseURL(process.env.REACT_APP_API_URL_EU)
        } else if ((rowData?.area || "").toLowerCase() === "apac") {
            setBaseURL(process.env.REACT_APP_API_URL_AU)
        }

    }, [rowData?.area])

    const deduplicatedFileData = (fileData || []).filter((item, index, self) => 
        index === self.findIndex(t => t.engagementId === item.engagementId)
    );

    const exportFieldConfig = useMemo(() => ([
        { key: 'engagementId', category: 'Engagement Id' },
        { key: 'engagementName', category: 'Engagement Name' },
        { key: 'clientName', category: 'Client Name' },
        { key: 'area', category: 'Area' },
        { key: 'country', category: 'Country' },
        { key: 'region', category: 'Region' },
        { key: 'targetArea', category: 'Target Area' },
        { key: 'targetCountry', category: 'Target Country' },
        { key: 'targetRegion', category: 'Target Region' },
        { key: 'sector', category: 'Sector' },
        { key: 'subSector', category: 'Sub Sector' },
        { key: 'subSubSector', category: 'Sub-Sub Sector' },
        { key: 'revenueRange', category: 'Revenue Range' },
        { key: 'function', category: 'Function' },
        { key: 'transactionType', category: 'Transaction Type' },
        { key: 'engagementId_GUID', category: 'Engagement GUID' },
        { key: 'partnerName', category: 'Partner Name' },
        { key: 'engagementPartnerEmail', category: 'Engagement Partner Email' },
        { key: 'sortCodes', category: 'Sort Codes' },
        { key: 'engagementStatus', category: 'Engagement Status' }
    ]), []);

    const exportFilterOptions = useMemo(() => {
        return exportFieldConfig
            .map((field) => {
                const uniqueValues = Array.from(
                    new Set(
                        deduplicatedFileData
                            .map((item) => item?.[field.key])
                            .filter((value) => value !== undefined && value !== null && String(value).trim() !== "")
                            .map((value) => String(value).trim())
                    )
                ).sort((a, b) => a.localeCompare(b));

                return {
                    ...field,
                    options: uniqueValues.map((value) => ({
                        id: value,
                        label: value
                    }))
                };
            })
            .filter((field) => field.options.length > 0);
    }, [deduplicatedFileData, exportFieldConfig]);

    const partnerNameToEmailMap = useMemo(() => {
        const mapping = new Map();
        (deduplicatedFileData || []).forEach((item) => {
            const partner = String(item?.partnerName || '').trim();
            const email = String(item?.engagementPartnerEmail || '').trim();
            if (!partner || !email) return;
            if (!mapping.has(partner)) mapping.set(partner, new Set());
            mapping.get(partner).add(email);
        });
        return mapping;
    }, [deduplicatedFileData]);

    const handleApplyExcelExport = useCallback((selectedOptions) => {
        const payload = {};

        exportFieldConfig.forEach((field) => {
            const selectedValues = selectedOptions?.[field.key] || [];
            if (selectedValues.length > 0) {
                payload[field.key] = selectedValues.join(",");
            } else {
                payload[field.key] = null;
            }
        });

        const selectedPartnerNames = (selectedOptions?.partnerName || []).map((name) => String(name || '').trim()).filter(Boolean);
        const selectedPartnerEmails = (selectedOptions?.engagementPartnerEmail || []).map((email) => String(email || '').trim()).filter(Boolean);
        const mappedPartnerEmails = selectedPartnerNames.flatMap((name) => Array.from(partnerNameToEmailMap.get(name) || []));
        const uniquePartnerEmails = Array.from(new Set([...selectedPartnerEmails, ...mappedPartnerEmails]));

        payload.partnerName = null;
        payload.engagementPartnerEmail = uniquePartnerEmails.length > 0 ? uniquePartnerEmails.join(',') : null;

        dispatch(adminExportExcelRequest(payload));
    }, [dispatch, exportFieldConfig, partnerNameToEmailMap]);

    const filteredData = deduplicatedFileData.filter((item) => {
        const engagementIdValid = item?.engagementId && item.engagementId.trim() !== '';
        
        // If no search value, return all valid engagement items
        if (!searchValue || searchValue.trim() === '') {
            // Even when search is empty, still apply column filters if present
            const hasAnyFilter = Object.values(columnFilters).some(v => !!v && v.trim() !== "");
            if (!hasAnyFilter) return engagementIdValid;
        }

        // Convert searchValue to lowercase once for efficiency
        const lowerCaseSearchValue = searchValue.toLowerCase();

        // Convert searchValue to a number if it's a valid numeric string
        const numericSearchValue = !isNaN(searchValue) ? Number(searchValue) : null;

        // Check if any of the specified fields contain the searchValue
        const searchMatch = (
            (item?.engagementId && item.engagementId.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.engagementName && item.engagementName.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.clientName && item.clientName.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.area && item.area.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.region && item.region.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.country && item.country.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.targetArea && item.targetArea.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.targetCountry && item.targetCountry.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.targetRegion && item.targetRegion.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.sector && item.sector.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.subSector && item.subSector.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.subSubSector && item.subSubSector.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.revenueRange && item.revenueRange.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.function && item.function.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.sortCodes && String(item.sortCodes).toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.transactionType && item.transactionType.toLowerCase().includes(lowerCaseSearchValue)) ||
            (numericSearchValue !== null && item?.goldBadge === numericSearchValue) || // Check goldBadge
            (item?.partnerName && item.partnerName.toLowerCase().includes(lowerCaseSearchValue)) ||
            (item?.engagementPartnerEmail && item.engagementPartnerEmail.toLowerCase().includes(lowerCaseSearchValue))
        );

        // Column-wise filters (all applicable filters must match)
        const normalize = (v) => String(v || "").toLowerCase();
        const f = {
            engagementId: normalize(columnFilters.engagementId),
            goldBadge: normalize(columnFilters.goldBadge),
            clientName: normalize(columnFilters.clientName),
            engagementName: normalize(columnFilters.engagementName),
            area: normalize(columnFilters.area),
            country: normalize(columnFilters.country),
            transactionType: normalize(columnFilters.transactionType),
            function: normalize(columnFilters.function),
            sortCodes: normalize(columnFilters.sortCodes),
            sector: normalize(columnFilters.sector),
            subSector: normalize(columnFilters.subSector),
            subSubSector: normalize(columnFilters.subSubSector),
            revenueRange: normalize(columnFilters.revenueRange),
            partnerName: normalize(columnFilters.partnerName)
        };

        const matchesGoldBadge = () => {
            if (!f.goldBadge) return true;
            const guid = item.engagementId_GUID || item.engagementId;
            const entry = adminGoldCountsData?.data?.[guid];
            const processed = Number(entry?.goldProcessedFiles) || 0;
            const total = Number(entry?.totalFiles) || 0;
            const display = `${processed}/${total}`;
            return normalize(display).includes(f.goldBadge);
        };

        const matchesColumnFilters = (
            (!f.engagementId || normalize(item.engagementId).includes(f.engagementId)) &&
            (!f.clientName || normalize(item.clientName).includes(f.clientName)) &&
            (!f.engagementName || normalize(item.engagementName).includes(f.engagementName)) &&
            (!f.area || normalize(item.area).includes(f.area)) &&
            (!f.country || normalize(item.country).includes(f.country)) &&
            (!f.transactionType || normalize(item.transactionType).includes(f.transactionType)) &&
            (!f.function || normalize(item.function).includes(f.function)) &&
            (!f.sortCodes || normalize(item.sortCodes).includes(f.sortCodes)) &&
            (!f.sector || normalize(item.sector).includes(f.sector)) &&
            (!f.subSector || normalize(item.subSector).includes(f.subSector)) &&
            (!f.subSubSector || normalize(item.subSubSector).includes(f.subSubSector)) &&
            (!f.revenueRange || normalize(item.revenueRange).includes(f.revenueRange)) &&
            (!f.partnerName || normalize(item.partnerName).includes(f.partnerName)) &&
            matchesGoldBadge()
        );

        // Include the item if engagementId is valid AND matches search AND filters
        return engagementIdValid && searchMatch && matchesColumnFilters;
    });



    useEffect(() => {
        
        if (adminEngagementData?.data && adminEngagementData?.status === ApiStatus.SUCCESS) {
            const rawData = adminEngagementData.data || [];
            const uniqueData = rawData.filter((item, index, self) => 
                index === self.findIndex(t => t.engagementId === item.engagementId)
            );
            
            if (rawData.length !== uniqueData.length) {
                logger.warn("Duplicate records detected and removed:", rawData.length - uniqueData.length, "duplicates");
            }
            
            setIsLoading(false);
            setFileData(uniqueData);
        } else if (adminEngagementData?.error) {
            logger.error("API Error:", adminEngagementData?.error);
            setFileData([]); // Fallback to static data
            setIsLoading(false);
        } else if (adminEngagementData?.status === ApiStatus.LOADING) {
            setIsLoading(true);
        } else /* istanbul ignore next */ if (adminEngagementData?.status === ApiStatus.ERROR) {
            setFileData([]); setIsLoading(false);
        /* istanbul ignore next */
        } else if (adminEngagementData?.status === ApiStatus.NONE) {
            logger.info("API Status is NONE - initial state, waiting for mount useEffect to trigger API");
        }
    }, [adminEngagementData, navigation, adminEngagementData?.status]);

  

    const onFilterTextBoxChanged = (value) => {
        setSearchValue(value);
    };

    /* istanbul ignore next */
    const onUserFilterTextBoxChanged = (value) => {
        setSearchUser(value);
    };

    /* istanbul ignore next */
    const getEngagementData = useCallback((engagementId, region, showLoader) => {
        setIsLoading(showLoader);
        try {
            const payload = { engagementId, region, email: getAccount()?.username, isEngagementAdmin: userProfileDetails?.isEngagementAdmin };
            if (getAccount()?.username) {
                dispatch(getFilesEngagementData(payload));
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                navigation("/");
            } else {
                logger.error("An error occurred:", error);
                setIsLoading(false);
            }
        }
    }, [dispatch, navigation]);

    useEffect(() => {
        if (filesEngagementData?.status === ApiStatus.SUCCESS) {
            setEngagementData(filesEngagementData?.data);
            setIsLoading(false);
        }
    }, [filesEngagementData?.data, filesEngagementData?.status]);

   
    /* istanbul ignore next */
    const CustomCellRendererTooltip = (params) => {
        const { value, data, colDef } = params;
         const uniqueId = `${colDef.field}-${data?.engagementId || data?.id || ''}`;

        const handleCopy = () => {
            if (navigator && navigator.clipboard) {
                navigator.clipboard.writeText(value);
                setCopied(true);
                setCopiedValue(uniqueId);
                setTimeout(() => setCopied(false), 1000); // Reset after 1s
            }
        };
        const cellStyle = {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: 100,
            display: "inline-block",
            backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
            color: copied && copiedValue === uniqueId ? "#fff" : undefined,
            transition: "background 0.2s",
            cursor: "pointer"
        };

        return (
            <div onClick={handleCopy}>
                <span
                    title={value}
                    style={cellStyle}
                >
                    {value}
                </span>
            </div>
        );
    };

    /* istanbul ignore next */
    const getCachedAvatarUrl = (id) => {
        try {
            const stored = sessionStorage.getItem("asyncAvatarCache_v1");
            if (!stored) return "";
            const obj = JSON.parse(stored);
            const entry = obj?.[id];
            if (!entry) return "";
            if (typeof entry === "string") return entry || "";
            return entry.url || "";
        } catch (e) {
            return "";
        }
    };

    /* istanbul ignore next */
    const columnDefs =
        [
            
            {
                field: "engagementId",
                sortable: true,
                filter: true,
                headerName: "Engagement Id",
                width: 200,
                cellRenderer: (params) => {
                    const { value, data } = params;
                    const isExpanded = expandedRows.has(value);
                    const uniqueId = `engagementId-${value}`;
                    
                    const handleCopy = () => {
                        if (navigator && navigator.clipboard) {
                            navigator.clipboard.writeText(value);
                            setCopied(true);
                            setCopiedValue(uniqueId);
                            setTimeout(() => setCopied(false), 1000);
                        }
                    };

                    const handleToggle = (e) => {
                        e.stopPropagation();
                        toggleRowExpansion(value, data.engagementId_GUID, data.area);
                    };

                    const cellStyle = {
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: "100%"
                    };

                    const expandButtonStyle = {
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "12px",
                        color: "#666",
                        padding: "2px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: "16px",
                        height: "16px"
                    };

                    const valueStyle = {
                        backgroundColor: copied && copiedValue === uniqueId ? "transparent" : "transparent",
                        color: copied && copiedValue === uniqueId ? "#fff" : "#fff",
                        transition: "background 0.2s",
                        cursor: "pointer",
                        padding: "2px 4px",
                        borderRadius: "2px",
                        fontWeight: "600"
                    };

                    return (
                        <div style={cellStyle} title={value}>
                            <button 
                                style={expandButtonStyle}
                                onClick={handleToggle}
                                title={isExpanded ? "Collapse" : "Expand"}
                            >
                                {isExpanded ? "▼" : "►"}
                            </button>
                            <span style={valueStyle} onClick={handleCopy}>
                                {value}
                            </span>
                        </div>
                    );
                },
                // cellRendererFramework

            },
             {
                field: "goldBadge",
                sortable: true,
                filter: true,
                headerName: "Gold Badge",
                width: 160,
                cellRenderer: (params) => {
                    const row = params.data || {};
                    const guid = row.engagementId_GUID ;
                    const counts = adminGoldCountsData?.data?.[guid];
                    const isLoading = adminGoldCountsData?.status === ApiStatus.LOADING && !counts;
                    const hasData = !!counts;
                    if (isLoading) {
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px' }}>
                                <MotifProgressLoader show variant="default" />
                            </div>
                        );
                    }
                    if (!hasData) {
                        return <span style={{ color: '#888' }}>-</span>;
                    }
                    const totalFiles = Number(counts?.totalFiles ?? 0);
                    const goldProcessedFiles = Number(counts?.goldProcessedFiles ?? 0);
                    const allDone = totalFiles > 0 && goldProcessedFiles === totalFiles;
                    const bg = allDone ? '#c8e6c9' : '#ffe0b2';
                    const color = allDone ? '#2e7d32' : '#e65100';
                    const displayText = `${String(goldProcessedFiles)}/${String(totalFiles)} files`;
                    return (
                        <span title={`Gold processed: ${displayText}`}
                              style={{ background: bg, color, padding: '2px 6px', borderRadius: '12px', fontSize: '12px', display: 'inline-block', minWidth: '120px', textAlign: 'center' }}>
                            {displayText}
                        </span>
                    );
                },
                // cellRendererFramework

            },
            {
                field: "clientName",
                sortable: true,
                filter: true,
                enablefilter: true,
                headerName: "Client Name",
                width: 175,
                resizable: true,
                cellRenderer: CustomCellRendererTooltip, // Apply custom renderer with tooltip
            },
             {
                field: "engagementName",
                sortable: true,
                filter: true,
                enablefilter: true,
                headerName: "Engagement Name",
                width: 175,
                resizable: true,
                cellRenderer: CustomCellRendererTooltip, // Apply custom renderer with tooltip
            },
              {
                field: "area",
                sortable: true,
                filter: true,
                headerName: "Area",
                width: 160,
                resizable: true,
                cellRenderer: CustomCellRendererTooltip
            },
            {
                field: "country",
                sortable: true,
                filter: true,
                headerName: "Country",
                width: 155,
                resizable: true,
                cellRenderer: CustomCellRendererTooltip
            },
            {
                field: "transactionType",
                sortable: true,
                filter: true,
                headerName: "Transaction Type",
                width: 179,
                resizable: true,
                cellRenderer: CustomCellRendererTooltip, // Apply custom renderer with tooltip
            },
            {
                field: "function",
                sortable: true,
                filter: true,
                headerName: "Function",
                width: 200,
                resizable: true,
                cellRenderer: CustomCellRendererTooltip
            },
              {
                field: "sector",
                sortable: true,
                filter: true,
                headerName: "Sector",
                width: 125,
                resizable: true,
                cellRenderer: CustomCellRendererTooltip
            },
            {
                field: "subSector",
                sortable: true,
                filter: true,
                headerName: "Sub Sector",
                width: 145,
                resizable: true,
                cellRenderer: CustomCellRendererTooltip
            },

            {
                field: "subSubSector",
                sortable: true,
                filter: true,
                headerName: "Sub-Sub Sector",
                width: 170,
                resizable: true,
                cellRenderer: CustomCellRendererTooltip
            },
            {
                field: "revenueRange",
                sortable: true,
                filter: true,
                headerName: "Reported Revenue Range",
                width: 225,
                resizable: true,
                cellRenderer: CustomCellRendererTooltip
            },
            {
                field: "partnerName",
                sortable: true,
                filter: true,
                headerName: "Partner Name",
                width: 200,
                resizable: true,
                cellClass: "actions-header-right-partner-name-cells",
                cellRenderer: (params) => {
                    // Add copy-to-clipboard functionality with unique identification
                    const uniqueId = `partnerName-${params.data.engagementId}`;
                    const name = params?.data?.partnerName || '';
                    const avatarId = params?.data?.engagementPartnerEmail || params?.data?.partnerName || '';
                    const containerStyle = {
                        display: 'flex',
                        alignItems: 'left',
                        gap: '8px',
                        overflow: 'hidden',
                        marginLeft: '-8px'
                    };
                    const nameStyle = {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '120px',
                        marginLeft: "10px",
                        backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
                        color: copied && copiedValue === uniqueId ? "#fff" : undefined,
                        transition: "background 0.2s",
                        cursor: "pointer"
                    };
                    const cachedAvatar = avatarId ? getCachedAvatarUrl(avatarId) : "";
                    const handleCopy = () => {
                        if (navigator && navigator.clipboard) {
                            navigator.clipboard.writeText(name);
                            setCopied(true);
                            setCopiedValue(uniqueId);
                            setTimeout(() => setCopied(false), 1000); // Reset after 1s
                        }
                    };
                    return (
                        <div style={containerStyle} title={name}>
                            {cachedAvatar ? (
                                <img
                                    src={cachedAvatar}
                                    alt={name}
                                    style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover', marginLeft: '9px' }}
                                />
                            ) : (
                                <div  style={{marginRight:'9.5px'}}>
                                <AsyncAvatar id={avatarId} name={name} size="small"  />
                                </div>
                            )}<div style={nameStyle} onClick={handleCopy}>{name}</div>
                        </div>
                    );
                }
            }
        ];

    // Detail cell renderer for expanded rows
    const DetailCellRenderer = ({ data }) => {
        
        const engagementGUID = data.engagementId_GUID || data.engagementId; // Fallback to engagementId if GUID not available
        
        const fileData = adminFilesData?.data?.[engagementGUID]?.data || [];
        const [fileSearch, setFileSearch] = useState("");
        const fileLevelDetailsArr = adminOriginalFileNamesData?.data?.[engagementGUID]?.data || [];
        const originalNamesMap = React.useMemo(() => {
            const m = {};
            fileLevelDetailsArr.forEach(item => {
                if (item && (item.controlId !== undefined && item.controlId !== null)) {
                    m[item.controlId] = item.orignalFileName || item.originalFileName || '';
                }
            });
            return m;
        }, [fileLevelDetailsArr]);
        const fileSizeMap = React.useMemo(() => {
            const m = {};
            fileLevelDetailsArr.forEach(item => {
                if (item && (item.controlId !== undefined && item.controlId !== null)) {
                    m[item.controlId] = item.fileSize || item.fileSize || '';
                }
            });
            return m;
        }, [fileLevelDetailsArr]);
        const fileModifiedDateMap = React.useMemo(() => {
            const m = {};
            fileLevelDetailsArr.forEach(item => {
                if (item && (item.controlId !== undefined && item.controlId !== null)) {
                    m[item.controlId] = item.fileModifiedDate || item.fileModifiedDate || '';
                }
            });
            return m;
        }, [fileLevelDetailsArr]);
    const isLoadingFiles = adminFilesData?.data?.[engagementGUID]?.status === ApiStatus.LOADING || false;
    const isLoadingFileNames = adminOriginalFileNamesData?.data?.[engagementGUID]?.status === ApiStatus.LOADING || false;
    const fileError = adminFilesData?.data?.[engagementGUID]?.error || null;
    const fileNamesError = adminOriginalFileNamesData?.data?.[engagementGUID]?.error || null;
    const showLoader = isLoadingFiles || isLoadingFileNames;

        // Use parent-level selection state so selections persist and can be aggregated
        const selectedControlIds = selectedControlsByEngagement[engagementGUID] || new Set();

        const startAnonState = adminStartAnonymizationData?.data?.[engagementGUID];
        const isStartingAnon = startAnonState?.status === ApiStatus.LOADING;
        const isAnonStartedForSession = startAnonState?.status === ApiStatus.SUCCESS;
        const anonSuccessMessage = startAnonState?.status === ApiStatus.SUCCESS ? startAnonState?.message : null;
        const anonErrorMessage = startAnonState?.status === ApiStatus.ERROR ? startAnonState?.error : null;

        /* istanbul ignore next */
        const handleStartAnonymization = () => {
            if (isStartingAnon || selectedControlIds.size === 0) return;
            const encryptedNames = fileData
                .filter(f => selectedControlIds.has(String(f.controlId)) && f.encryptedFileName)
                .map(f => f.encryptedFileName);
            if (encryptedNames.length === 0) return;
            dispatch(adminStartAnonymizationRequest({ engagementGUID, area: data.area, blobFileNames: encryptedNames }));
        };

        /* istanbul ignore next */
        const handleToggleControl = (controlId, checked) => {
            setSelectedControlsByEngagement(prev => {
                const existing = prev[engagementGUID] || new Set();
                const next = new Set(existing);
                const key = String(controlId); // normalize to string to avoid number/string mismatch
                if (checked) next.add(key); else next.delete(key);
                return { ...prev, [engagementGUID]: next };
            });
        };

        const normalizedQuery = (fileSearch || "").toLowerCase();
        const filteredFiles = (fileData || []).filter(f => {
            if (!normalizedQuery) return true;
            const cols = [
                String(f?.controlId || ""),
                f?.encryptedFileName || "",
                // original file might come from API map
                originalNamesMap[f?.controlId] || f?.originalFileName || f?.orignalFileName || "",
                f?.sanitizedFileName || "",
                f?.uploadedBy || ""
            ].map(v => String(v).toLowerCase());
            return cols.some(v => v.includes(normalizedQuery));
        });

        // Sort so bookmarked rows appear first while preserving original order within groups
        const sortedFiles = React.useMemo(() => {
            const withIndex = (filteredFiles || []).map((f, i) => ({ f, i }));
            withIndex.sort((a, b) => {
                const aB = !!a.f?.isBookmarked;
                const bB = !!b.f?.isBookmarked;
                if (aB === bB) return a.i - b.i; // preserve original order
                return bB - aB; // bookmarked first
            });
            return withIndex.map(x => x.f);
        }, [filteredFiles]);

        const fileColumnDefs = [
            {
                field: "isBookmarked",
                headerName: "Starred",
                width: 80,
                pinned: 'left',
                lockPinned: true,
                suppressMovable: true,
                sortable: true,
                filter: true,
                headerClass: 'starred-header-cell',
                cellStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
                cellRenderer: (params) => {
                    const controlId = params?.data?.controlId;
                    const controlIdKey = String(controlId);
                    const isBookmarked = !!params?.data?.isBookmarked;
                    const bookmarkEntry = (adminBookmarkFileData?.data || {})[controlIdKey];
                    const isBookmarkLoading = bookmarkEntry?.status === ApiStatus.LOADING;

                    const onToggleBookmark = (e) => {
                        e.stopPropagation();
                        if (isBookmarkLoading) return;
                        const parentArea = data.area;
                        dispatch(adminBookmarkFileRequest({
                            controlId,
                            isBookmarked: !isBookmarked,
                            engagementGUID,
                            area: parentArea
                        }));
                    };

                    return (
                        <button
                            type="button"
                            aria-label={isBookmarked ? 'Remove bookmark' : 'Add bookmark'}
                            onClick={onToggleBookmark}
                            disabled={isBookmarkLoading}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: isBookmarkLoading ? 'not-allowed' : 'pointer',
                                opacity: isBookmarkLoading ? 0.65 : (isBookmarked ? 1 : 0.35),
                                padding: 0,
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%'
                            }}
                            title={isBookmarked ? 'Bookmarked' : 'Bookmark'}
                        >
                            <img
                                src={require(`../../common/images/${isBookmarked ? 'bookmarked.png' : 'bookmark.png'}`)}
                                alt="bookmark"
                                style={{ width: '20px', height: '20px' }}
                            />
                        </button>
                    );
                }
            },
            {
                field: "controlId",
                headerName: "Control ID",
                width: 120,
                pinned: 'left',
                lockPinned: true,
                suppressMovable: true,
                sortable: true,
                filter: true,
                cellRenderer: (params) => {
                    const { value } = params;
                    const stringValue = String(value);
                    const isChecked = selectedControlIds.has(stringValue);
                    /* istanbul ignore next */
                    const hasSanitized = (() => {
                        const val = params?.data?.sanitizedFileName;
                        if (typeof val === 'string') return val.trim().length > 0;
                        return !!val;
                    })();

                    /* istanbul ignore next */
                    const onChange = (e) => {
                        if (isAnonStartedForSession || isStartingAnon) return;
                        // Some AG Grid / Motif versions pass boolean directly, others pass event
                        const nextChecked = e && e.target ? e.target.checked : !!e;
                        handleToggleControl(stringValue, nextChecked);
                        // Prevent row click / selection side-effects
                    };
                    const handleCopy = () => {
                        if (navigator && navigator.clipboard) {
                            navigator.clipboard.writeText(value);
                        }
                    };

                    return (
                        <div className="control-id-cell" title={value}>
                            <MotifCheckbox
                                id={`ctrl-${engagementGUID}-${stringValue}`}
                                value={stringValue}
                                checked={isChecked}
                                onChange={onChange}
                                className="control-id-checkbox"
                                disabled={hasSanitized || isAnonStartedForSession || isStartingAnon}
                            />
                            <span className="control-id-text" onClick={handleCopy}>{value}</span>
                        </div>
                    );
                }
            },
            {
                field: "encryptedFileName",
                headerName: "Encrypted File Name",
                width: 200,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    const v = params?.data?.encryptedFileName;
                    return v == null ? '' : String(v);
                },
                getQuickFilterText: (params) => {
                    const v = params?.data?.encryptedFileName;
                    return v == null ? '' : String(v);
                },
                cellRenderer: (params) => {
                    const { value } = params;
                    const uniqueId = `encryptedFileName-${value}`;
                    
                    const handleCopy = () => {
                        if (navigator && navigator.clipboard) {
                            navigator.clipboard.writeText(value);
                            setCopied(true);
                            setCopiedValue(uniqueId);
                            setTimeout(() => setCopied(false), 1000);
                        }
                    };

                    const cellStyle = {
                        backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
                        color: copied && copiedValue === uniqueId ? "#fff" : "#333",
                        transition: "background 0.2s",
                        cursor: "pointer",
                        padding: "4px 8px",
                        borderRadius: "2px",
                        display: 'inline-block',
                        maxWidth: '150px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        verticalAlign: 'middle'
                    };

                    return (
                        <span style={cellStyle} onClick={handleCopy} title={value}>
                            {value}
                        </span>
                    );
                }
            },
            {
                field: "originalFileName",
                headerName: "Original File Name",
                width: 190,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    const ctrl = params?.data?.controlId;
                    const mapped = originalNamesMap[ctrl];
                    const fallback = params?.data?.originalFileName || params?.data?.orignalFileName || '';
                    return String(mapped || fallback || '');
                },
                getQuickFilterText: (params) => {
                    const ctrl = params?.data?.controlId;
                    const mapped = originalNamesMap[ctrl];
                    const fallback = params?.data?.originalFileName || params?.data?.orignalFileName || '';
                    return String(mapped || fallback || '');
                },
                cellRenderer: (params) => {
                    const { value, data } = params;
                    const effectiveOriginal = originalNamesMap[data.controlId] || value || '';
                    const uniqueId = `originalFileName-${effectiveOriginal}`;
                    const handleCopy = () => {
                        if (navigator && navigator.clipboard) {
                            navigator.clipboard.writeText(effectiveOriginal);
                            setCopied(true);
                            setCopiedValue(uniqueId);
                            setTimeout(() => setCopied(false), 1000);
                        }
                    };
                    const cellStyle = {
                        backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
                        color: copied && copiedValue === uniqueId ? "#fff" : "#333",
                        transition: "background 0.2s",
                        cursor: "pointer",
                        padding: "4px 8px",
                        borderRadius: "2px",
                        display: 'inline-block',
                        maxWidth: '140px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        verticalAlign: 'middle'
                    };
                    return <span style={cellStyle} onClick={handleCopy} title={effectiveOriginal}>{effectiveOriginal}</span>;
                }
            },
             {
                field: "fileSize",
                headerName: "File Size (in MB)",
                width: 170,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    const ctrl = params?.data?.controlId;
                    const mapped = fileSizeMap[ctrl];
                    const fallback = params?.data?.fileSize;
                    return String(mapped ?? fallback ?? '');
                },
                getQuickFilterText: (params) => {
                    const ctrl = params?.data?.controlId;
                    const mapped = fileSizeMap[ctrl];
                    const fallback = params?.data?.fileSize;
                    return String(mapped ?? fallback ?? '');
                },
                cellRenderer: (params) => {
                    const { value, data } = params;
                    const effectiveOriginal = fileSizeMap[data.controlId] || value || '';
                    const uniqueId = `fileSize-${effectiveOriginal}`;
                    const handleCopy = () => {
                        if (navigator && navigator.clipboard) {
                            navigator.clipboard.writeText(effectiveOriginal);
                            setCopied(true);
                            setCopiedValue(uniqueId);
                            setTimeout(() => setCopied(false), 1000);
                        }
                    };
                    const cellStyle = {
                        backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
                        color: copied && copiedValue === uniqueId ? "#fff" : "#333",
                        transition: "background 0.2s",
                        cursor: "pointer",
                        padding: "4px 8px",
                        borderRadius: "2px",
                        display: 'inline-block',
                        maxWidth: '140px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        verticalAlign: 'middle'
                    };
                    return <span style={cellStyle} onClick={handleCopy} title={effectiveOriginal}>{effectiveOriginal}</span>;
                }
            },
             {
                field: "fileModifiedDate",
                headerName: "Date Modified",
                width: 150,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    const ctrl = params?.data?.controlId;
                    const raw = fileModifiedDateMap[ctrl] || params?.data?.fileModifiedDate || '';
                    if (typeof raw !== 'string' || !raw.length) return String(raw || '');
                    const isoMatch = raw.match(/^(\d{4}-\d{2}-\d{2})T/);
                    if (isoMatch) return isoMatch[1];
                    const d = new Date(raw);
                    if (!isNaN(d.getTime())) return d.toISOString().slice(0, 10);
                    return raw;
                },
                getQuickFilterText: (params) => {
                    const ctrl = params?.data?.controlId;
                    const raw = fileModifiedDateMap[ctrl] || params?.data?.fileModifiedDate || '';
                    if (typeof raw !== 'string' || !raw.length) return String(raw || '');
                    const isoMatch = raw.match(/^(\d{4}-\d{2}-\d{2})T/);
                    if (isoMatch) return isoMatch[1];
                    const d = new Date(raw);
                    if (!isNaN(d.getTime())) return d.toISOString().slice(0, 10);
                    return raw;
                },
                cellRenderer: (params) => {
                    const { value, data } = params;
                    const rawValue = fileModifiedDateMap[data.controlId] || value || '';
                    let displayValue = rawValue;
                    if (typeof rawValue === 'string' && rawValue.length) {
                        const isoMatch = rawValue.match(/^(\d{4}-\d{2}-\d{2})T/);
                        if (isoMatch) {
                            displayValue = isoMatch[1];
                        } else {
                            const d = new Date(rawValue);
                            if (!isNaN(d.getTime())) {
                                displayValue = d.toISOString().slice(0, 10); // yyyy-mm-dd
                            }
                        }
                    }
                    const uniqueId = `fileModifiedDate-${rawValue}`;
                    const handleCopy = () => {
                        if (navigator && navigator.clipboard) {
                            navigator.clipboard.writeText(displayValue);
                            setCopied(true);
                            setCopiedValue(uniqueId);
                            setTimeout(() => setCopied(false), 1000);
                        }
                    };
                    const cellStyle = {
                        backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
                        color: copied && copiedValue === uniqueId ? "#fff" : "#333",
                        transition: "background 0.2s",
                        cursor: "pointer",
                        padding: "4px 8px",
                        borderRadius: "2px",
                        display: 'inline-block',
                        maxWidth: '140px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        verticalAlign: 'middle'
                    };
                    return <span style={cellStyle} onClick={handleCopy} title={rawValue}>{displayValue}</span>;
                }
            },
            {
                field: "sanitizedFileName",
                headerName: "Sanitized File Name",
                width: 190,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    const v = params?.data?.sanitizedFileName;
                    return v == null ? '' : String(v);
                },
                getQuickFilterText: (params) => {
                    const v = params?.data?.sanitizedFileName;
                    return v == null ? '' : String(v);
                },
                cellRenderer: (params) => {
                    const { value } = params;
                    const uniqueId = `sanitizedFileName-${value}`;
                    
                    const handleCopy = () => {
                        if (navigator && navigator.clipboard) {
                            navigator.clipboard.writeText(value);
                            setCopied(true);
                            setCopiedValue(uniqueId);
                            setTimeout(() => setCopied(false), 1000);
                        }
                    };

                    const cellStyle = {
                        backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
                        color: copied && copiedValue === uniqueId ? "#fff" : "#333",
                        transition: "background 0.2s",
                        cursor: "pointer",
                        padding: "4px 8px",
                        borderRadius: "2px",
                        display: 'inline-block',
                        maxWidth: '140px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        verticalAlign: 'middle'
                    };

                    return (
                        <span style={cellStyle} onClick={handleCopy} title={value}>
                            {value}
                        </span>
                    );
                }
            },
            {
                field: "uploadedBy",
                headerName: "Files Uploaded By",
                width: 180,
                sortable: true,
                filter: true,
                cellRenderer: (params) => {
                    const { value } = params;
                    const cellStyle = {
                        display: 'inline-block',
                        maxWidth: '210px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        // padding: '4px 6px',
                        verticalAlign: 'middle'
                    };
                    return <span style={cellStyle} title={value}>{value}</span>;
                }
            },
             {
                field: "anonymisationStatus",
                headerName: "Anonymisation Status",
                width: 180,
                sortable: true,
                cellRenderer: (params) => {
                    const { value } = params;
                    const statusColors = {
                        'Processed': '#4caf50',
                        'Processing': '#ff9800',
                        'Failed': '#f44336'
                    };
                    
                    const cellStyle = {
                        color: statusColors[value] || '#333',
                        fontWeight: '600',
                        fontSize: '12px'
                    };
                      const normalized = (value || '').toString().toLowerCase();
                    const anonymisationStatus = normalized === 'sanitization completed';
                  
                   const rawScore = params.data?.anonymisationScore;
                    let scorePercent = null;
                    /* istanbul ignore next -- score display intentionally disabled */
                    if (typeof rawScore === 'number' && rawScore > 0) {
                        scorePercent = rawScore <= 1 ? Math.round(rawScore * 100) : Math.round(rawScore);
                        if (scorePercent > 100) scorePercent = 100;
                    }
                    scorePercent=null; // disable score display for now

                    const circle = anonymisationStatus
                        ? (scorePercent !== null
                            ? <span className="tick-circle score-value" title={`Anonymisation Score ${scorePercent}%`}>{scorePercent}</span>
                            : <span className="tick-circle" title="Completed">✓</span>)
                        : <span className="pending-circle" title={value || 'Pending'}><span className="inner-dot" /></span>;
                    return (
                        <div className={`layer-progress no-connectors connector-start`} title={value || 'Pending'}>
                            <span className="progress-connector-line" aria-hidden="true" />
                            {circle}
                        </div>
                    );

                }
            },
            // {
            //     field: "validationStatus",
            //     headerName: "Validation Status",
            //     width: 160,
            //     sortable: true,
            //     cellRenderer: (params) => {
            //         // If KPI Extraction completed show tick, else pending circle
            //         const kpiNorm = (params.data?.kpiExtraction || '').toString().toLowerCase();
            //         const kpiExtractionCompleted = kpiNorm === 'data extraction completed';
            //         const circle = kpiExtractionCompleted
            //             ? <span className="tick-circle" title="Completed">✓</span>
            //             : <span className="pending-circle" title={params.value || 'Pending'}><span className="inner-dot" /></span>;
            //         return (
            //             <div className="layer-progress no-connectors full-width-line" title={params.value || 'Pending'}>
            //                 <span className="progress-connector-line" aria-hidden="true" />
            //                 {circle}
            //             </div>
            //         );
            //     }
                
            // },
            {
                field: "kpiExtraction",
                headerName: "KPI Extraction",
                width: 150,
                sortable: true,
                cellRenderer: (params) => {
                    const { value } = params;
                    const statusColors = {
                        'Processed': '#4caf50',
                        'Processing': '#ff9800',
                        'Failed': '#f44336'
                    };
                    
                    const cellStyle = {
                        color: statusColors[value] || '#333',
                        fontWeight: '600',
                        fontSize: '12px'
                    };
                    const normalized = (value || '').toString().toLowerCase();
                    const kpiExtractionCompleted = normalized === 'data extraction completed';
                  

                    const circle = kpiExtractionCompleted
                        ? <span className="tick-circle" title="Completed">✓</span>
                        : <span className="pending-circle" title={value || 'Pending'}><span className="inner-dot" /></span>;
                    return (
                        <div className="layer-progress no-connectors full-width-line" title={value || 'Pending'}>
                            <span className="progress-connector-line" aria-hidden="true" />
                            {circle}
                        </div>
                    );
                }
                
            },
            {
                field: "bronzeLayer",
                headerName: "Bronze Layer",
                width: 130,
                sortable: true,
                cellRenderer: (params) => {
                    const { value, data } = params;
                    const normalized = (value || '').toString().toLowerCase();
                    const bronzeCompleted = normalized === 'completed';
                    const silverCompleted = (data?.silverLayer || '').toString().toLowerCase() === 'completed';
                    // line to right active only if both current and next completed
                    const circle = bronzeCompleted
                        ? <span className="tick-circle" title="Completed">✓</span>
                        : <span className="pending-circle" title={value || 'Pending'}><span className="inner-dot" /></span>;
                    return (
                        <div className="layer-progress no-connectors full-width-line" title={value || 'Pending'}>
                            <span className="progress-connector-line" aria-hidden="true" />
                            {circle}
                        </div>
                    );
                },
                
                
            },
            {
                field: "silverLayer",
                headerName: "Silver Layer",
                width: 130,
                sortable: true,
                cellRenderer: (params) => {
                    const { value, data } = params;
                    const normalized = (value || '').toString().toLowerCase();
                    const silverCompleted = normalized === 'completed';
                    const bronzeCompleted = (data?.bronzeLayer || '').toString().toLowerCase() === 'completed';
                    const goldCompleted = (data?.goldLayer || '').toString().toLowerCase() === 'completed';
                    const circle = silverCompleted
                        ? <span className="tick-circle" title="Completed">✓</span>
                        : <span className="pending-circle" title={value || 'Pending'}><span className="inner-dot" /></span>;
                    return (
                        <div className="layer-progress no-connectors full-width-line" title={value || 'Pending'}>
                            <span className="progress-connector-line" aria-hidden="true" />
                            {circle}
                        </div>
                    );
                }
                
            },
            {
                field: "goldLayer",
                headerName: "Gold Layer",
                width: 130,
                sortable: true,
                cellRenderer: (params) => {
                    const { value, data } = params;
                    const normalized = (value || '').toString().toLowerCase();
                    const goldCompleted = normalized === 'completed';
                    const silverCompleted = (data?.silverLayer || '').toString().toLowerCase() === 'completed';
                    const circle = goldCompleted
                        ? <span className="tick-circle" title="Completed">✓</span>
                        : <span className="pending-circle" title={value || 'Pending'}><span className="inner-dot" /></span>;
                    return (
                        <div className="layer-progress no-connectors connector-end" title={value || 'Pending'}>
                            <span className="progress-connector-line" aria-hidden="true" />
                            {circle}
                        </div>
                    );
                }
                
            },
            {
                field: "actions",
                headerName: "Actions",
                width: 170,
                pinned: 'right',
                cellRenderer: (params) => {
                    const row = params.data || {};
                    // Only enable actions if a true sanitizedFileName exists
                    const sanitizedOriginal = row.sanitizedFileName; // strict requirement
                    const hasSanitized = !!sanitizedOriginal;
                    // We keep a fallback for display purposes but only act when hasSanitized
                    const sanitized = sanitizedOriginal || row.encryptedFileName || row.originalFileName;
                    const parentArea = data.area;
                    const downloadState = adminDownloadFileData?.data?.[sanitized];
                    const isDownloading = downloadState?.status === ApiStatus.LOADING;
                    // Determine if a manual upload for this sanitized file is currently processing
                    const isUploadingThis = hasSanitized && Object.entries(adminManualUploadData?.data || {})
                        .some(([reqId, info]) => info?.status === ApiStatus.LOADING && reqId.startsWith(`${sanitizedOriginal}-`));

                    const handleDownload = (e) => {
                        e.stopPropagation();
                        if (!hasSanitized) return; // guard: only sanitized allowed
                        dispatch(adminDownloadFileRequest({ fileName: sanitizedOriginal, area: parentArea }));
                    };

                    const handleUploadClick = (e) => {
                        e.stopPropagation();
                        if (!hasSanitized) return; // guard
                        setManualUploadFiles([]);
                        setManualUploadError(null);
                        setManualUploadRequestId(`${sanitizedOriginal}-${Date.now()}`);
                        setManualUploadArea(parentArea);
                        setShowManualUploadDialog(true);
                    };

                    return (
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <button
                                type="button"
                                aria-label="Download file"
                                className="download-file-btn"
                                onClick={handleDownload}
                                disabled={isDownloading || !hasSanitized}
                                title={hasSanitized ? (isDownloading ? 'Downloading...' : `Download ${sanitizedOriginal}`) : 'Sanitized file not available'}
                                style={{
                                    background: 'transparent',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    cursor: (isDownloading || !hasSanitized) ? 'not-allowed' : 'pointer',
                                    color: (isDownloading || !hasSanitized) ? '#999' : '#333',
                                    padding: '4px',
                                    minWidth: '32px',
                                    height: '25px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {isDownloading ? '⏳' : <MotifIcon src={downloadIcon} />}
                            </button>
                            {isUploadingThis ? (
                                <button
                                    type="button"
                                    aria-label="Uploading file"
                                    disabled
                                    title="Uploading..."
                                    style={{
                                        background: 'transparent',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        cursor: 'not-allowed',
                                        color: '#999',
                                        padding: '4px 8px',
                                        minWidth: '70px',
                                        height: '25px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px'
                                    }}
                                >
                                    {'⏳'}
                                </button>
                            ) : (
                                <MotifButton
                                    size="small"
                                    variant="primary"
                                    onClick={handleUploadClick}
                                    title={hasSanitized ? `Upload manually validated files` : 'Sanitized file not available'}
                                    disabled={!hasSanitized}
                                    style={{ height: '25px' }}
                                >Upload</MotifButton>
                            )}
                        </div>
                    );
                }
            }
        ];

        return (
            <div className="detail-table-container detail-table-container--responsive">
                {(fileError || fileNamesError) ? (
                    <div style={{ padding: "20px", textAlign: "center", color: "#f44336" }}>
                        {fileError && <p>Error loading files: {fileError}</p>}
                        {fileNamesError && <p>Error loading original names: {fileNamesError}</p>}
                    </div>
                ) : fileData.length === 0 ? (
                    <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
                        <p>No files found for this engagement.</p>
                    </div>
                ) : (
                    <div className="file-table-wrapper" style={{ width: '100%', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px', margin: '8px', paddingRight: '10px' }}>
                            <MotifButton
                                variant='primary'
                                size='small'
                                disabled={isStartingAnon || (selectedControlIds?.size || 0) === 0}
                                title={isStartingAnon ? 'Anonymization in progress' : 'Start Anonymization'}
                                onClick={handleStartAnonymization}
                                style={{ height: '40px' }}
                            >
                                {isStartingAnon ? 'Starting...' : 'Start Anonymization'}
                            </MotifButton>
                            <div className="motif-search-input-wrapper" style={{ position: 'relative', width: '220px' }}>
                                <MotifSearch
                                    aria-label="Search files"
                                    placeholder="Search..."
                                    value={fileSearch}
                                    onChange={(e) => setFileSearch(e.target?.value)}
                                    style={{ height: '40px' }}
                                />
                               
                            </div>
                        </div>
                        <MotifTable
                            columnDefs={fileColumnDefs}
                            rowData={sortedFiles}
                            variant="compact"
                            pagination={false}
                            domLayout="normal"
                            headerHeight={40}
                            rowHeight={40}
                            zebra={true}
                            suppressHorizontalScroll={false}
                            enableRangeSelection={true}
                            enableCellSelection={true}
                            style={{ height: '360px', width: '100%' }}
                        />
                        <div style={{ height: '11px' }} />
                    </div>
                )}
            </div>
        );
    };

    const scrollableColumns = columnDefs;//.slice(1, -2); // Middle columns
    const anySelectedControls = Object.values(selectedControlsByEngagement).some(set => set && set.size > 0);
    const isAnyAnonLoading = Object.entries(adminStartAnonymizationData?.data || {}).some(([, v]) => v?.status === ApiStatus.LOADING);
    const aggregatedAnonMessages = Object.entries(adminStartAnonymizationData?.data || {})
        .filter(([, v]) => v?.status === ApiStatus.SUCCESS)
        .map(([guid, v]) => ({ guid, message: v.message }));
    const aggregatedAnonErrors = Object.entries(adminStartAnonymizationData?.data || {})
        .filter(([, v]) => v?.status === ApiStatus.ERROR)
        .map(([guid, v]) => ({ guid, error: v.error }));

     /* istanbul ignore next */
     useEffect(() => {
        if (!adminStartAnonymizationData?.data) return;
        setSelectedControlsByEngagement(prev => {
            let mutated = false;
            const next = { ...prev };
            Object.entries(adminStartAnonymizationData.data).forEach(([guid, info]) => {
                if ((info?.status === ApiStatus.SUCCESS || info?.status === ApiStatus.ERROR) && next[guid] && next[guid].size > 0) {
                    next[guid] = new Set(); // clear selections regardless of success or error
                    mutated = true;
                }
            });
            return mutated ? next : prev;
        });
    }, [adminStartAnonymizationData]);

    const downloadStatusHistoryRef = useRef({});
    const hasMountedRef = useRef(false);
    useEffect(() => {
        const entries = Object.entries(adminDownloadFileData?.data || {});
        for (const [fileName, info] of entries) {
            const currentStatus = info?.status;
            const prevStatus = downloadStatusHistoryRef.current[fileName]?.lastStatus;
            const transitioned = prevStatus !== currentStatus;
            const isTerminal = currentStatus === ApiStatus.SUCCESS || currentStatus === ApiStatus.ERROR;

            if (transitioned) {
                // Always record status
                downloadStatusHistoryRef.current[fileName] = { lastStatus: currentStatus };
                // Only toast if terminal and previous state was LOADING (fresh completion), never on initial mount
                const cameFromLoading = prevStatus === ApiStatus.LOADING;
                if (hasMountedRef.current && isTerminal && cameFromLoading) {
                    if (currentStatus === ApiStatus.SUCCESS) {
                        setAdminToastVariant('success');
                        setAdminToastTitle('Successfully downloaded');
                        setAdminToastSubtitle('Please upload a valid file to continue');
                        setAdminToastVisible(true);
                    } else {
                        setAdminToastVariant('warning');
                        setAdminToastTitle('Download failed');
                        setAdminToastSubtitle(info?.error || 'Please retry.');
                        setAdminToastVisible(true);
                    }
                }
            }
        }
        if (!hasMountedRef.current) {
            // After first evaluation, mark mounted so subsequent transitions can trigger toasts
            hasMountedRef.current = true;
        }
    }, [adminDownloadFileData]);

    const adminExportStatusRef = useRef(ApiStatus.NONE);
    useEffect(() => {
        const currentStatus = adminExportExcelData?.status;
        const prevStatus = adminExportStatusRef.current;
        adminExportStatusRef.current = currentStatus;

        if (prevStatus === ApiStatus.LOADING && currentStatus === ApiStatus.SUCCESS) {
            setAdminToastVariant('success');
            setAdminToastTitle('Export completed');
            setAdminToastSubtitle('Excel file downloaded successfully.');
            setAdminToastVisible(true);
        }

        if (prevStatus === ApiStatus.LOADING && currentStatus === ApiStatus.ERROR) {
            setAdminToastVariant('warning');
            setAdminToastTitle('Export failed');
            setAdminToastSubtitle(adminExportExcelData?.error || 'Please retry.');
            setAdminToastVisible(true);
        }
    }, [adminExportExcelData]);

    // Watch anonymization start responses: toast only on LOADING -> SUCCESS/ERROR transitions
    const anonymizationStatusHistoryRef = useRef({}); // { engagementGUID: { lastStatus } }
    useEffect(() => {
        const entries = Object.entries(adminStartAnonymizationData?.data || {});
        for (const [guid, info] of entries) {
            const currentStatus = info?.status;
            const prevStatus = anonymizationStatusHistoryRef.current[guid]?.lastStatus;
            const transitioned = prevStatus !== currentStatus;
            const isTerminal = currentStatus === ApiStatus.SUCCESS || currentStatus === ApiStatus.ERROR;
            if (transitioned) {
                anonymizationStatusHistoryRef.current[guid] = { lastStatus: currentStatus };
                if (isTerminal && prevStatus === ApiStatus.LOADING) {
                    if (currentStatus === ApiStatus.SUCCESS) {
                        setAdminToastVariant('success');
                        // Prefer API message if present
                        const msg = info?.message || 'Anonymization started successfully.';
                        setAdminToastTitle('Anonymization started');
                        setAdminToastSubtitle(msg);
                        setAdminToastVisible(true);
                    } else {
                        setAdminToastVariant('warning');
                        setAdminToastTitle('Anonymization failed');
                        setAdminToastSubtitle(info?.error || 'Please retry.');
                        setAdminToastVisible(true);
                    }
                }
            }
        }
    }, [adminStartAnonymizationData]);

   useEffect(() => {
        const entries = Object.entries(adminManualUploadData?.data || {});
        for (const [reqId, info] of entries) {
            const currentStatus = info?.status;
            const prevStatus = uploadStatusHistoryRef.current[reqId]?.lastStatus;
            const transitioned = prevStatus !== currentStatus;
            const isTerminal = currentStatus === ApiStatus.SUCCESS || currentStatus === ApiStatus.ERROR;
            if (transitioned) {
                // Record new status
                uploadStatusHistoryRef.current[reqId] = { lastStatus: currentStatus };
                // Only toast if terminal and directly transitioned from LOADING (fresh completion)
                if (isTerminal && prevStatus === ApiStatus.LOADING) {
                    const now = Date.now();
                    lastUploadRef.current = now;
                    if (currentStatus === ApiStatus.SUCCESS) {
                        setAdminToastVariant('success');
                        setAdminToastTitle('Successfully Uploaded');
                        setAdminToastSubtitle('File Uploaded successfully.');
                        setAdminToastVisible(true);
                    } else {
                        setAdminToastVariant('warning');
                        setAdminToastTitle('Upload failed');
                        setAdminToastSubtitle(info?.error || 'Please retry.');
                        setAdminToastVisible(true);
                    }
                }
            }
        }
    }, [adminManualUploadData]);
    
    const engagementIds = filteredData.map(item => item.engagementId);
    const uniqueEngagementIds = [...new Set(engagementIds)];
   
    const paginatedData = filteredData.slice(startIndex, endIndex);
     const enrichedPaginatedData = paginatedData.map(row => ({
        ...row,
        isExpanded: expandedRows.has(row.engagementId)
    }));

    useEffect(() => {
         if (filteredData.length > 0) {
            if (startIndex >= filteredData.length) {
                setCurrentPage(1);
            }
        } else {
            setCurrentPage(1);
        }
        if (searchValue) {
            setExpandedRows(new Set());
        }
    }, [searchValue, filteredData.length]);

    useEffect(() => {
        const mainScrollElement = document.getElementById('main-table-scroll');
        const stickyScrollElement = document.getElementById('sticky-scrollbar');
        const stickyScrollContent = stickyScrollElement?.querySelector('.sticky-scrollbar-content');
        
        if (!mainScrollElement || !stickyScrollElement || !stickyScrollContent) return;

        const updateStickyScrollWidth = () => {
            const mainTableContent = mainScrollElement.querySelector('.custom-accordion-table');
            const stickyContainer = document.querySelector('.sticky-scrollbar-container');
            
            if (mainTableContent && stickyContainer) {
                 const scrollWidth = Math.max(mainTableContent.scrollWidth, PARENT_TABLE_WIDTH);
                const clientWidth = mainScrollElement.clientWidth;
                
                stickyScrollContent.style.width = scrollWidth + 'px';
                
                if (scrollWidth >= PARENT_TABLE_WIDTH || scrollWidth > clientWidth) {
                    stickyContainer.style.display = 'block';
                } else {
                    /* istanbul ignore next */
                    stickyContainer.style.display = 'none';
                }
            }
        };

        const syncMainToSticky = () => {
            stickyScrollElement.scrollLeft = mainScrollElement.scrollLeft;
        };

        const syncStickyToMain = () => {
            mainScrollElement.scrollLeft = stickyScrollElement.scrollLeft;
        };

         mainScrollElement.addEventListener('scroll', syncMainToSticky);
        stickyScrollElement.addEventListener('scroll', syncStickyToMain);
        
        // Initial setup and on resize
        updateStickyScrollWidth();
        window.addEventListener('resize', updateStickyScrollWidth);

        // Watch for DOM changes (like accordion expansions) that might change table width
        const observer = new MutationObserver(() => {
            updateStickyScrollWidth();
        });
        
        observer.observe(mainScrollElement, {
            childList: true,
            subtree: true,
            attributes: true
        });

        // Cleanup
        return () => {
            mainScrollElement.removeEventListener('scroll', syncMainToSticky);
            stickyScrollElement.removeEventListener('scroll', syncStickyToMain);
            window.removeEventListener('resize', updateStickyScrollWidth);
            observer.disconnect();
        };
    }, [filteredData]); // Re-run when data changes

   
    return (
        <div className="partnerFiles-container">
            {isAccordionPageLoading && (
                <div className="admin-fullpage-loader-overlay">
                    <MotifProgressLoader show variant="default" />
                </div>
            )}
            {filteredData && (
                <div className="grid-wrapper">
                    <TableHeader
                        onFilterTextBoxChanged={onFilterTextBoxChanged}
                        searchValue={searchValue}
                        navigation={navigation}
                        callingFrom="adminPage"
                        showExportExcel
                        openExportExcel={() => setIsExportExcelPanelOpen(true)}
                        isExportExcelLoading={adminExportExcelData?.status === ApiStatus.LOADING}
                    />

                    <div className="grid-container">
                        <div className="ag-theme-quartz grid-container-inner">
                            {isLoading ? (
                                <MotifProgressLoader show variant="default" />
                            ) : (
                                <>
                                    <div className="motif-table-wrap">
                                        <div className="table-container admin-table-scroll" id="main-table-scroll">
                                            <table
                                                className="admin-landing-table"
                                                style={{ width: `${PARENT_TABLE_WIDTH}px`, minWidth: `${PARENT_TABLE_WIDTH}px` }}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th className="sticky-col-left" style={{ width: "165px" }}>Engagement Id</th>
                                                        <th style={{ width: "120px" }}>Gold Badge</th>
                                                        <th style={{ width: "145px" }}>Client Name</th>
                                                        <th style={{ width: "145px" }}>Engagement Name</th>
                                                        <th style={{ width: "140px" }}>Area</th>
                                                        <th style={{ width: "100px" }}>Country</th>
                                                        <th style={{ width: "145px" }}>Transaction Type</th>
                                                        <th style={{ width: "165px" }}>Function</th>
                                                        <th style={{ width: "130px" }}>Sort Code</th>
                                                        <th style={{ width: "100px" }}>Sector</th>
                                                        <th style={{ width: "115px" }}>Sub Sector</th>
                                                        <th style={{ width: "125px" }}>Sub-Sub Sector</th>
                                                        <th style={{ width: "165px" }}>Revenue Range</th>
                                                        <th className="sticky-col-right" style={{ width: "205px" }}>Partner Name</th>
                                                    </tr>
                                                    <tr>
                                                        <th className="sticky-col-left" style={{ width: "165px" }}>
                                                            <input
                                                                type="text"
                                                                placeholder="Search..."
                                                                value={columnFilters.engagementId}
                                                                onChange={(e) => setColumnFilters(prev => ({ ...prev, engagementId: e.target.value }))}
                                                                style={{ width: '100%' }}
                                                            />
                                                        </th>
                                                        <th style={{ width: "120px" }}>
                                                            <input
                                                                type="text"
                                                                placeholder="Search..."
                                                                value={columnFilters.goldBadge}
                                                                onChange={(e) => setColumnFilters(prev => ({ ...prev, goldBadge: e.target.value }))}
                                                                style={{ width: '100%' }}
                                                            />
                                                        </th>
                                                        <th style={{ width: "145px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.clientName} onChange={(e) => setColumnFilters(prev => ({ ...prev, clientName: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th style={{ width: "145px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.engagementName} onChange={(e) => setColumnFilters(prev => ({ ...prev, engagementName: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th style={{ width: "140px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.area} onChange={(e) => setColumnFilters(prev => ({ ...prev, area: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th style={{ width: "100px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.country} onChange={(e) => setColumnFilters(prev => ({ ...prev, country: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th style={{ width: "145px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.transactionType} onChange={(e) => setColumnFilters(prev => ({ ...prev, transactionType: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th style={{ width: "165px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.function} onChange={(e) => setColumnFilters(prev => ({ ...prev, function: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th style={{ width: "130px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.sortCodes} onChange={(e) => setColumnFilters(prev => ({ ...prev, sortCodes: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th style={{ width: "100px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.sector} onChange={(e) => setColumnFilters(prev => ({ ...prev, sector: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th style={{ width: "115px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.subSector} onChange={(e) => setColumnFilters(prev => ({ ...prev, subSector: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th style={{ width: "125px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.subSubSector} onChange={(e) => setColumnFilters(prev => ({ ...prev, subSubSector: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th style={{ width: "165px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.revenueRange} onChange={(e) => setColumnFilters(prev => ({ ...prev, revenueRange: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                        <th className="sticky-col-right" style={{ width: "205px" }}>
                                                            <input type="text" placeholder="Search..." value={columnFilters.partnerName} onChange={(e) => setColumnFilters(prev => ({ ...prev, partnerName: e.target.value }))} style={{ width: '100%' }} />
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {enrichedPaginatedData.map((row) => (
                                                        <React.Fragment key={row.engagementId}>
                                                            <tr className={`data-row ${row.isExpanded ? "expanded" : ""}`}>
                                                                <td className="engagement-cell sticky-col-left" style={{ width: "165px" }}>
                                                                    <button
                                                                        className="expand-button"
                                                                        onClick={() => toggleRowExpansion(row.engagementId, row.engagementId_GUID, row.area)}
                                                                        aria-label={row.isExpanded ? "Collapse row" : "Expand row"}
                                                                    >
                                                                        {row.isExpanded ? "▼" : "►"}
                                                                    </button>
                                                                    <span
                                                                        className="engagement-id-text"
                                                                        title="Click to copy"
                                                                        onClick={() => navigator.clipboard?.writeText(row.engagementId)}
                                                                    >
                                                                        {row.engagementId}
                                                                    </span>
                                                                </td>
                                                                <td
                                                                    className="gold-badge-cell"
                                                                    style={{ width: "160px" }}
                                                                    title="Gold Badge"
                                                                >
                                                                    {(() => {
                                                                        const status = adminGoldCountsData?.status;
                                                                        const guid = row.engagementId_GUID || row.engagementId;
                                                                        const entry = adminGoldCountsData?.data?.[guid];
                                                                        if (status === ApiStatus.LOADING) {
                                                                            return (
                                                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                                                    <MotifProgressLoader show variant="default" />
                                                                                    <span style={{ fontSize: '11px', color: '#666' }}>Syncing…</span>
                                                                                </span>
                                                                            );
                                                                        }
                                                                        if (entry && typeof entry === 'object') {
                                                                            const processed = Number(entry.goldProcessedFiles) || 0;
                                                                            const total = Number(entry.totalFiles) || 0;
                                                                            const display = `${processed}/${total} files`;
                                                                            const isMatch = processed === total && total > 0;
                                                                            const containerStyle = isMatch
                                                                                ? { backgroundColor: '#E7FCE8', color: '#197335' }
                                                                                : { backgroundColor: '#FCF5F0', color: '#975100' };
                                                                            return (
                                                                                <span
                                                                                    style={{
                                                                                        ...containerStyle,
                                                                                        display: 'inline-block',
                                                                                        padding: '2px 8px',
                                                                                        borderRadius: '999px',
                                                                                        fontWeight: 600,
                                                                                        fontSize: '12px',
                                                                                        lineHeight: '18px'
                                                                                    }}
                                                                                >
                                                                                    {display}
                                                                                </span>
                                                                            );
                                                                        }
                                                                        return <span>-</span>;
                                                                    })()}
                                                                </td>
                                                                <td
                                                                    style={{ width: "145px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.clientName)}
                                                                >
                                                                    {row.clientName}
                                                                </td>
                                                                <td
                                                                    style={{ width: "145px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.engagementName)}
                                                                >
                                                                    {row.engagementName}
                                                                </td>
                                                                <td
                                                                    style={{ width: "120px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.area)}
                                                                >
                                                                    {row.area}
                                                                </td>
                                                                <td
                                                                    style={{ width: "100px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.country)}
                                                                >
                                                                    {row.country}
                                                                </td>
                                                                <td
                                                                    style={{ width: "145px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.transactionType)}
                                                                >
                                                                    {row.transactionType}
                                                                </td>
                                                                <td
                                                                    style={{ width: "165px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.function)}
                                                                >
                                                                    {row.function}
                                                                </td>
                                                                <td
                                                                    style={{ width: "130px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.sortCodes)}
                                                                >
                                                                    {row.sortCodes}
                                                                </td>
                                                                <td
                                                                    style={{ width: "100px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.sector)}
                                                                >
                                                                    {row.sector}
                                                                </td>
                                                                <td
                                                                    style={{ width: "115px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.subSector)}
                                                                >
                                                                    {row.subSector}
                                                                </td>
                                                                <td
                                                                    style={{ width: "125px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.subSubSector)}
                                                                >
                                                                    {row.subSubSector}
                                                                </td>
                                                                <td
                                                                    style={{ width: "165px" }}
                                                                    title="Click to copy"
                                                                    onClick={() => navigator.clipboard?.writeText(row.revenueRange)}
                                                                >
                                                                    {row.revenueRange}
                                                                </td>
                                                                <td className="sticky-col-right" style={{ width: "205px" }}>
                                                                    <div className="partner-cell">
                                                                        <AsyncAvatar
                                                                            id={row.engagementPartnerEmail || row.partnerName}
                                                                            name={row.partnerName}
                                                                            size="small"
                                                                        />
                                                                        <span className="partner-name-text" title="Click to copy" onClick={() => navigator.clipboard?.writeText(row.partnerName)}>
                                                                            {row.partnerName}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            {row.isExpanded && (
                                                                <tr className="expanded-row">
                                                                    <td colSpan={15}>
                                                                        <DetailCellRenderer data={row} />
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    {/* Sticky Horizontal Scrollbar */}
                                    <div className="sticky-scrollbar-container">
                                        <div className="sticky-scrollbar-track" id="sticky-scrollbar">
                                            <div className="sticky-scrollbar-content" />
                                        </div>
                                    </div>
                                    <MotifPagination
                                        allowInput
                                        aria-label="Pagination Navigation"
                                        currentPage={currentPage}
                                        firstButtonProps={{ title: "Go to first page" }}
                                        lastButtonProps={{ title: "Go to last page" }}
                                        max={Math.ceil(filteredData.length / rowsPerPage)}
                                        min={1}
                                        nextButtonProps={{ title: "Go to next page" }}
                                        onPageChange={handlePageChange}
                                        prevButtonProps={{ title: "Go to previous page" }}
                                        role="navigation"
                                        className="motif-pagination"
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginTop: '8px', gap: '12px' }}>
                                        {/* <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                            {aggregatedAnonMessages.length === 0 && aggregatedAnonErrors.length === 0 && (
                                                <span style={{ color: anySelectedControls ? '#555' : '#888', fontSize: '11px' }}>
                                                    {anySelectedControls ? 'Ready to start anonymization for selected files.' : 'Select files to start anonymization.'}
                                                </span>
                                            )}
                                        </div> */}
                                        {/* <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <MotifButton
                                                variant='primary'
                                                disabled={!anySelectedControls || isAnyAnonLoading}
                                                onClick={() => {
                                                    if (!anySelectedControls || isAnyAnonLoading) return;
                                                    Object.entries(selectedControlsByEngagement).forEach(([guid, set]) => {
                                                        if (!set || set.size === 0) return;
                                                        const fileRecords = adminFilesData?.data?.[guid]?.data || [];
                                                        const encryptedNames = fileRecords
                                                            .filter(r => set.has(String(r.controlId)) && r.encryptedFileName)
                                                            .map(r => r.encryptedFileName);
                                                        if (encryptedNames.length === 0) return;
                                                        const engagementRow = fileData.find(row => row.engagementId_GUID === guid || row.engagementId === guid);
                                                        const area = engagementRow?.area;
                                                        dispatch(adminStartAnonymizationRequest({ engagementGUID: guid, area, blobFileNames: encryptedNames }));
                                                    });
                                                    // Toast will be shown based on API response in effect watcher
                                                }}
                                                title={isAnyAnonLoading ? 'Anonymization in progress' : 'Start Anonymization'}
                                            >
                                                {isAnyAnonLoading ? 'Starting...' : 'Start Anonymization'}
                                            </MotifButton>
                                        </div> */}
                                    </div>
                                </>
                            )}
                        </div>
                                                {showManualUploadDialog && (
                                                    <Dialog
                                                        open={showManualUploadDialog}
                                                        onClose={/* istanbul ignore next */ () => setShowManualUploadDialog(false)}
                                                        fullWidth
                                                        maxWidth="sm"
                                                    >
                                                        <DialogTitle sx={{ pr: 5 }}>
                                                            <IconButton
                                                                aria-label="close"
                                                                onClick={() => setShowManualUploadDialog(false)}
                                                                sx={{ position: 'absolute', right: 8, top: 8 }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                            <div style={{ fontSize: '16px', fontWeight: 600 }}>Upload Manually Validated Files</div>
                                                        </DialogTitle>
                                                        <DialogContent dividers>
                                                            <div
                                                                style={{ border: '1px dashed #999', padding: '20px', textAlign: 'center', borderRadius: '4px', background:'#fafafa', cursor:'pointer' }}
                                                                onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                                                onDrop={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    const dropped = Array.from(e.dataTransfer.files || []);
                                                                    setManualUploadFiles(dropped);
                                                                    setManualUploadError(null);
                                                                }}
                                                                onClick={() => {
                                                                    const input = document.getElementById('manual-upload-input');
                                                                    if (input) input.click();
                                                                }}
                                                            >
                                                                {manualUploadFiles.length === 0 ? (
                                                                    <span style={{ fontSize:'12px' }}>Drop files here or click to select</span>
                                                                ) : (
                                                                    <ul style={{ textAlign:'left', maxHeight:'150px', overflowY:'auto', margin:0, padding:0 }}>
                                                                        {manualUploadFiles.map(f => <li key={f.name} style={{ listStyle:'none', fontSize:'12px', padding:'2px 0' }}>{f.name}</li>)}
                                                                    </ul>
                                                                )}
                                                                <input
                                                                    type="file"
                                                                    multiple
                                                                    style={{ display:'none' }}
                                                                    id="manual-upload-input"
                                                                    onChange={(e) => {
                                                                        const filesArr = Array.from(e.target.files || []);
                                                                        setManualUploadFiles(filesArr);
                                                                        setManualUploadError(null);
                                                                    }}
                                                                />
                                                                <label htmlFor="manual-upload-input" style={{ display:'block', marginTop:'8px', cursor:'pointer', fontSize:'12px', color:'#1976d2' }}>Browse...</label>
                                                            </div>
                                                            {manualUploadError && <div style={{ color:'#d32f2f', fontSize:'12px', marginTop:'8px' }}>{manualUploadError}</div>}
                                                            {manualUploadFiles.length > 0 && (
                                                                <div style={{ fontSize:'11px', color:'#555', marginTop:'4px', textAlign:'left' }}>
                                                                    {manualUploadFiles.length} file{manualUploadFiles.length > 1 ? 's' : ''} ready to upload.
                                                                </div>
                                                            )}
                                                        </DialogContent>
                                                        <DialogActions>
                                                            <MotifButton variant="tertiary" onClick={() => setShowManualUploadDialog(false)}>Close</MotifButton>
                                                            <MotifButton
                                                                variant="primary"
                                                                disabled={manualUploadFiles.length === 0}
                                                                onClick={() => {
                                                                    /* istanbul ignore next */
                                                                    if (manualUploadFiles.length === 0) return;
                                                                    dispatch(adminUploadFileRequest({ files: manualUploadFiles, area: manualUploadArea, requestId: manualUploadRequestId }));
                                                                    setShowManualUploadDialog(false);
                                                                }}
                                                            >Confirm & Extract KPIs</MotifButton>
                                                        </DialogActions>
                                                    </Dialog>
                                                )}
                    </div>
                </div>
            )}
            <AdminExportExcelPanel
                show={isExportExcelPanelOpen}
                onClose={() => setIsExportExcelPanelOpen(false)}
                exportOptions={exportFilterOptions}
                onApply={handleApplyExcelExport}
                isExporting={adminExportExcelData?.status === ApiStatus.LOADING}
            />
            {adminToastVisible && (
                <div className="admin-toast-container">
                    <MotifToast
                        open={adminToastVisible}
                        variant={adminToastVariant}
                        className="admin-toast"
                        position="top"
                        onClose={() => setAdminToastVisible(false)}
                    >
                        <div style={{ textAlign: 'left' }}>
                            {adminToastTitle && <div style={{ fontWeight: 600, fontSize: '13px', marginBottom: adminToastSubtitle ? '4px' : 0 }}>{adminToastTitle}</div>}
                            {adminToastSubtitle && <div style={{ fontSize: '12px', lineHeight: 1.4 }}>{adminToastSubtitle}</div>}
                        </div>
                    </MotifToast>
                </div>
            )}
        </div>
    );
};